import omitBy from 'lodash/omitBy';
import isArray from 'lodash/isArray';

const isEmptyArray = (value) => isArray(value) && !value.length;

export const omitEmpty = (object) =>
  omitBy(object, (value) => value === undefined || value === null || value === '' || isEmptyArray(value));
